import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SignupForm from './components/SignupForm';
import LoginForm from './components/LoginForm';
import Modal from '../../components/lib/Modal';
import GlassCard from '../../components/lib/GlassCard';

import { updateLoginModalOpen, updateUserProject } from '../../../../../../reducers/_Pages/Public/radarSlice';

import USERS from '../../../../../../../shared/apiPublic/ressources/users';
import safeLocalStorage from '../../../../../../../shared/utils/safeLocalStorage';
import { getUser } from '../../../../../../reducers/App/userSlice';

const LoginSignupModal = () => {
  const { loginModalOpen } = useSelector((state) => state.radar);
  const [login, setLogin] = useState(false)
  const [formValues, setFormValues] = useState({ email: '', password: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    setFormValues({ email: '', password: '' })
    setFormErrors({})
  }, [loginModalOpen]);

  const submitForm = async() => {
    setFormErrors({});
    setIsSubmitting(true);
    let response;

    if (login) {
      try {
        response = await USERS.signIn(formValues)

        if (response.data.error) {
          setIsSubmitting(false)
          setFormErrors({ password: [`${response.data.error}`] })
        }
      } catch (error) {
        if (error.message.includes('404')) setFormErrors({ email: ["Aucun compte actif n'est associé à cet email."] })
      } finally {
        setIsSubmitting(false);

        if (response?.data?.sign_in) {          
          handleUserLogin(response);
        }
      }
    } else {
      try {
        response = await USERS.createUser(formValues);

        if (response?.data?.token) {          
          handleUserLogin(response);
          dispatch(updateUserProject(formValues.project));
        }
      } catch (error) {
        setFormErrors(error.response?.data?.error);
        setIsSubmitting(false);

        if (error.response?.data?.error?.email?.[0]?.includes('Compte existant')) {
          setFormValues(prev => ({
            ...prev,
            password: '',
            passwordConfirmation: ''
          }));
          setLogin(true);
        }
      }
    }
  };

  const handleUserLogin = (response) => {
    safeLocalStorage.setItem('token', response.data.token);
    safeLocalStorage.setItem('customerId', response.data.user_id);
    dispatch(updateLoginModalOpen(false));
    dispatch(getUser());
  }

  return (
    <Modal isOpen={loginModalOpen} closeModal={() => dispatch(updateLoginModalOpen(false))}>
      <GlassCard hoverBgColor='' width='w-full md:w-96'>
        {login ?
          <LoginForm 
            formValues={formValues}
            setFormValues={setFormValues}
            setLogin={setLogin}
            submitForm={submitForm}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
            isSubmitting={isSubmitting} />
          :
          <SignupForm 
            formValues={formValues}
            setFormValues={setFormValues}
            setLogin={setLogin}
            submitForm={submitForm}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
            isSubmitting={isSubmitting }/>
        }
      </GlassCard>
    </Modal>
  )
}

export default LoginSignupModal;
